<main>
  <section class="customers-page__home">
    <div class="customers-page__home__bg">
      <fr8bot-web-video-autoplay
        [src]="videos.home"
        poster="/assets/image/web-main-home-video.webp"
        [priority]="true"
      />
    </div>

    <div class="customers-page__home__shadow"></div>

    <div class="customers-page__home__inner">
      <h1 class="customers-page__home__inner-title">
        <span class="customers-page__home__inner-title-hightlight">{{
          'landing.main.hero.titleHighlight' | translate
        }}</span>
        {{ 'landing.main.hero.title' | translate }}.
      </h1>

      <div class="customers-page__home__inner-info">
        <p>{{ 'landing.main.hero.subtitle' | translate }}.</p>
        <p class="customers-page__home__inner-info-list">
          <span>{{ 'landing.main.hero.features.tracking' | translate }}</span>
          <fr8bot-ui-icon
            class="customers-page__home__inner-info-polygon"
            name="web-polygon"
            [size]="{ width: 10, height: 12 }"
          />
          <span>{{ 'landing.main.hero.features.pricing' | translate }}</span>
          <fr8bot-ui-icon
            class="customers-page__home__inner-info-polygon"
            name="web-polygon"
            [size]="{ width: 10, height: 12 }"
          />
          <span>{{ 'landing.main.hero.features.booking' | translate }}</span>
        </p>
      </div>

      <div class="customers-page__home__inner-cards">
        <div class="customers-page-home-card">
          <div class="customers-page-home-card__inner">
            <div class="customers-page-home-card__inner-header">
              {{ 'landing.main.hero.shippersCard.header' | translate }}
              <fr8bot-ui-icon name="load-32" [size]="32" />
            </div>

            <div class="customers-page-home-card__inner-content">
              <div class="customers-page-home-card__inner-content-text">
                <h2 class="customers-page-home-card__inner-content-text-title">
                  {{ 'landing.main.hero.shippersCard.title' | translate }}
                </h2>
                <p class="customers-page-home-card__inner-content-text-subtitle">
                  {{ 'landing.main.hero.shippersCard.subtitle' | translate }}
                </p>
              </div>

              <fr8bot-ui-button
                type="primaryCut"
                size="large"
                class="customers-page-home-card__inner-content-button"
                data-testid="landing-hero-ship-now"
                (click)="landing.openAuthDialog(AUTH_CONTEXT.ShipLoadNow)"
              >
                {{ 'landing.main.hero.shippersCard.button' | translate }}
                <fr8bot-ui-icon postfix-icon name="arrow-right-16" [size]="16" />
              </fr8bot-ui-button>
            </div>
          </div>
        </div>

        <div class="customers-page-home-card">
          <div class="customers-page-home-card__inner">
            <div class="customers-page-home-card__inner-header">
              {{ 'landing.main.hero.driversCard.header' | translate }}
              <fr8bot-ui-icon name="van-32" [size]="32" />
            </div>

            <div class="customers-page-home-card__inner-content">
              <div class="customers-page-home-card__inner-content-text">
                <h2 class="customers-page-home-card__inner-content-text-title">
                  {{ 'landing.main.hero.driversCard.title' | translate }}
                </h2>
                <p class="customers-page-home-card__inner-content-text-subtitle">
                  {{ 'landing.main.hero.driversCard.subtitle' | translate }}
                </p>
              </div>

              <fr8bot-ui-button
                type="primaryCut"
                size="large"
                class="customers-page-home-card__inner-content-button"
                data-testid="landing-hero-drive"
                (click)="landing.openAuthDialog(AUTH_CONTEXT.CreateCarrierAccount)"
              >
                {{ 'landing.main.hero.driversCard.button' | translate }}
                <fr8bot-ui-icon postfix-icon name="arrow-right-16" [size]="16" />
              </fr8bot-ui-button>
            </div>
          </div>
        </div>
      </div>
    </div>
  </section>
  <!---->

  <!--  -->
  <fr8bot-web-statistics />
  <!--  -->

  <!--  -->
  <section class="what-fr8bot-section">
    <div class="trapeze what-fr8bot-section__trapeze"></div>

    <div class="what-fr8bot-section__bg">
      <img src="/assets/image/web-what-is-fr8bot.webp" alt="" />
    </div>

    <div class="what-fr8bot-section__pallet">
      <img src="/assets/image/web-pallete.webp" alt="" />
    </div>

    <div class="what-fr8bot-section__inner">
      <div class="what-fr8bot-section__inner-content">
        <span class="web-section-label">{{ 'landing.main.whatIsFr8bot.label' | translate }}?</span>

        <div class="what-fr8bot-section__inner-content-header">
          <h2 class="what-fr8bot-section__inner-content-header-title">
            {{ 'landing.main.whatIsFr8bot.titleStart' | translate }}
            <span class="what-fr8bot-section__inner-content-header-title-hightlight">
              {{ 'landing.main.whatIsFr8bot.titleHighlight' | translate }}
            </span>
            {{ 'landing.main.whatIsFr8bot.titleEnd' | translate }}
          </h2>
          <p class="what-fr8bot-section__inner-content-header-description">
            {{ 'landing.main.whatIsFr8bot.description' | translate }}
          </p>
        </div>
      </div>

      <fr8bot-ui-button
        class="what-fr8bot-section__inner-button"
        data-testid="landing-what-is-cta"
        type="primaryCut"
        size="large"
        (click)="landing.openCustomerCabinet()"
      >
        {{ 'landing.main.whatIsFr8bot.button' | translate }}
        <fr8bot-ui-icon postfix-icon name="arrow-right-16" [size]="16" />
      </fr8bot-ui-button>
    </div>
  </section>

  <!--  -->

  <fr8bot-web-critical-freight (shipNow)="landing.openAuthDialog(AUTH_CONTEXT.ShipLoadNow)" />

  <!--  -->

  <!--  -->
  <fr8bot-web-parallax-bg>
    <div class="trapeze trapeze--top"></div>
    <div class="web-section-shadow"></div>

    <div class="live-capacity-section__header">
      <span class="web-section-label">{{ 'landing.main.liveCapacity.label' | translate }}</span>

      <h2 class="live-capacity-section__header-title">
        {{ 'landing.main.liveCapacity.title' | translate }}
      </h2>
    </div>

    <div class="live-capacity-section__content">
      <div class="live-capacity-section__content-cards">
        <fr8bot-web-card-v-1
          [title]="'landing.main.liveCapacity.cards.map.title' | translate"
          [description]="'landing.main.liveCapacity.cards.map.description' | translate"
          icon="web-map"
        />

        <fr8bot-web-card-v-1
          [title]="'landing.main.liveCapacity.cards.pricing.title' | translate"
          [description]="'landing.main.liveCapacity.cards.pricing.description' | translate"
          icon="web-revenue"
        />

        <fr8bot-web-card-v-1
          [title]="'landing.main.liveCapacity.cards.certified.title' | translate"
          [description]="'landing.main.liveCapacity.cards.certified.description' | translate"
          icon="web-checkmark-approved"
        />

        <fr8bot-web-card-v-1
          [title]="'landing.main.liveCapacity.cards.visibility.title' | translate"
          [description]="'landing.main.liveCapacity.cards.visibility.description' | translate"
          icon="web-tracking"
        />

        <fr8bot-web-card-v-1
          [title]="'landing.main.liveCapacity.cards.tsaTwic.title' | translate"
          [description]="'landing.main.liveCapacity.cards.tsaTwic.description' | translate"
          icon="web-plane"
        />

        <fr8bot-web-card-v-1
          [title]="'landing.main.liveCapacity.cards.stack.title' | translate"
          [description]="'landing.main.liveCapacity.cards.stack.description' | translate"
          icon="web-plug"
        />

        <fr8bot-web-card-v-1
          [title]="'landing.main.liveCapacity.cards.paperwork.title' | translate"
          [description]="'landing.main.liveCapacity.cards.paperwork.description' | translate"
          icon="web-page"
        />

        <fr8bot-web-card-v-1
          [title]="'landing.main.liveCapacity.cards.insured.title' | translate"
          [description]="'landing.main.liveCapacity.cards.insured.description' | translate"
          icon="web-shield"
        />
      </div>

      <fr8bot-ui-button
        class="live-capacity-section__content-button"
        data-testid="landing-capacity-cta"
        type="primaryCut"
        size="large"
        (click)="landing.openCustomerCabinet()"
      >
        {{ 'landing.main.liveCapacity.button' | translate }}
        <fr8bot-ui-icon postfix-icon name="arrow-right-16" [size]="16" />
      </fr8bot-ui-button>
    </div>
  </fr8bot-web-parallax-bg>

  <!--  -->

  <fr8bot-web-about-section
    [videoSrc]="videos.trafficWhite"
    posterSrc="/assets/image/web-login-about-bg.webp"
    (shipNow)="landing.openAuthDialog(AUTH_CONTEXT.ShipLoadNow)"
  >
    <div class="trapeze trapeze--top"></div>
    <div class="trapeze"></div>

    <ng-container label>{{ 'landing.main.about.label' | translate }}</ng-container>

    <ng-container title>
      {{ 'landing.main.about.title1' | translate }}. <br />
      {{ 'landing.main.about.title2' | translate }}.
    </ng-container>

    <ng-container description>
      <p>{{ 'landing.main.about.p1' | translate }}</p>
      <p>{{ 'landing.main.about.p2' | translate }}</p>
      <p>{{ 'landing.main.about.p3' | translate }}</p>
    </ng-container>
  </fr8bot-web-about-section>

  <!--  -->
  <section class="about-fr8bot">
    <div class="about-fr8bot__inner">
      <div class="about-fr8bot__inner-logo">
        <fr8bot-ui-logo variant="small" [width]="35" [height]="25" />
      </div>

      <p class="about-fr8bot__inner-text">
        {{ 'landing.main.summary.text' | translate }}
      </p>
    </div>
  </section>
  <!--  -->
</main>
